import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import { CheckIcon } from 'lucide-react';

interface Rubric {
  scoringCategory: string;
  pointsScored: number;
  totalPoints: number;
  evaluationNotes?: string;
}

interface NewFrameworkRubric {
  category_name: string;
  is_completed: boolean;
}

export const renderRubricTable = (data: Rubric[]) => {
    const isCategoryCompleted = (pointsScored: number, totalPoints: number) => {
        return pointsScored === totalPoints;
      };

    return (
    <TableContainer component={Paper} sx={{ 
      bgcolor: 'transparent',
      boxShadow: 'none'
    }}>
      <Table>
        <TableHead>
          <TableRow sx={{ borderBottom: 1, borderColor: 'divider' , backgroundColor:  'background.default'}}>
            <TableCell sx={{ color: 'text.primary', fontWeight: 'medium' , backgroundColor:  'background.default' , borderColor: 'divider'}}>Status</TableCell>
            <TableCell sx={{ color: 'text.primary', fontWeight: 'medium' , backgroundColor:  'background.default' , borderColor: 'divider'}}>Scoring Category</TableCell>
            <TableCell align="center" sx={{ color: 'text.primary', fontWeight: 'medium',backgroundColor:  'background.default' , borderColor: 'divider'}}>Points Scored</TableCell>
            <TableCell align="center" sx={{ color: 'text.primary', fontWeight: 'medium' , backgroundColor:  'background.default' , borderColor: 'divider'}}>Total Points</TableCell>
            <TableCell align="center" sx={{ color: 'text.primary', fontWeight: 'medium', backgroundColor:  'background.default' , borderColor: 'divider'}}>Percentage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => {
            const percentage = Math.round((item.pointsScored / item.totalPoints) * 100);
            const isCompleted = isCategoryCompleted(item.pointsScored, item.totalPoints);
            
            return (
              <TableRow 
                key={index} 
                sx={{ 
                  borderBottom: 1, 
                  borderColor: 'divider',
                  '&:hover': {
                    bgcolor: 'background.paper'
                  }
                }}
              >
                <TableCell align="center" sx={{ borderColor: 'divider' }}>
                  {isCompleted ? (
                    <CheckIcon size={20} color="#4ade80" />
                  ) : (
                    <Box sx={{ 
                      width: 16, 
                      height: 16, 
                      borderRadius: '50%', 
                      border: 1, 
                      borderColor: 'text.primary',
                      mx: 'auto'
                    }} />
                  )}
                </TableCell>
                <TableCell sx={{ 
                  borderColor: 'divider',
                  fontWeight: 'medium',
                  color: isCompleted ? 'primary.main' : 'text.primary'
                }}>
                  {item.scoringCategory}
                  {item.evaluationNotes && (
                    <div style={{ margin: 0, paddingTop: '5px' }}>
                      {item.evaluationNotes.split(';').map((note, index) => (
                        <Typography key={index} variant="body2" color="text.secondary" style={{ paddingTop: '5px' }} component="div">
                          • {note.trim()}
                        </Typography>
                      ))}
                    </div>
                  )}
                </TableCell>
                <TableCell align="center" sx={{ color: 'primary.main', fontWeight: 'bold' , borderColor: 'divider'}}>
                  {item.pointsScored}
                </TableCell>
                <TableCell align="center" sx={{ color: 'text.primary' , borderColor: 'divider'}}>
                  {item.totalPoints}
                </TableCell>
                <TableCell align="center" sx={{ 
                  fontWeight: 'bold',
                  color: percentage === 100 ? '#4ade80' : percentage >= 50 ? '#facc15' : '#f87171' , 
                  borderColor: 'divider'
                }}>
                  {percentage}%
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export const renderFrameworkRubricTable = (data: NewFrameworkRubric[]) => {
  return (
    <TableContainer component={Paper} sx={{ 
      bgcolor: 'transparent',
      boxShadow: 'none'
    }}>
      <Table>
        <TableHead>
          <TableRow sx={{ borderBottom: 1, borderColor: 'divider', background: 'background.default' }}>
            <TableCell sx={{ color: 'text.primary', fontWeight: 'medium', background: 'background.default' }}>Status</TableCell>
            <TableCell sx={{ color: 'text.primary', fontWeight: 'medium', background: 'background.default' }}>Category</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow 
              key={index} 
              sx={{ 
                borderBottom: 1, 
                borderColor: 'divider',
                '&:hover': {
                  bgcolor: 'background.paper'
                }
              }}
            >
              <TableCell >
                {item.is_completed ? (
                  <CheckIcon size={20} color="primary.main" />
                ) : (
                  <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    borderRadius: '50%', 
                    border: 1, 
                    borderColor: 'divider',
                  }} />
                )}
              </TableCell>
              <TableCell sx={{ 
                fontWeight: 'medium',
                color: item.is_completed ? 'primary.main' : 'text.primary'
              }}>
                {item.category_name}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

